
import React, { useState, useRef, useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { 
  Banner,
  TopBar, 
  RecipeBuilder, 
  RecommendedRecipes, 
  Footer, 
  ArrowIndicator
} from './components';
import TermsModal from './components/TermsModal/TermsModal';
import ChatRecipeWidget from './components/ChatLunchRecipe/ChatRecipeWidget';
import RecipeDetailPage from './components/RecipeDetailPage/RecipeDetailPage';
import TermsPage from './components/TermsPage/TermsPage';
import ThankYouPage from './components/ThankYouPage/ThankYouPage';
import './App.css';
import useGlobalGaClickTracking from './analytics/digitalData';
import StoryTray from './components/StoryViewer/storybuilder';

function MainApp() {
  const [selectedRecipe, setSelectedRecipe] = useState(null);
  const topBarRef = useRef(null);
  const [showActions, setShowActions] = useState(true);
  const [showBanner, setShowBanner] = useState(true);

  const scrollToTop = () => {
    if (topBarRef.current) {
      topBarRef.current.scrollIntoView({ behavior: 'auto', block: 'start' });
    }
  };
  // Scroll to top on step change - targeting the correct scroll container
  useEffect(() => {
    // Scroll the section into view
    if (topBarRef.current) {
      topBarRef.current.scrollIntoView({ 
        behavior: 'auto', 
        block: 'start' 
      });
    }
  }, [selectedRecipe]);
  

  const handleRecipeSelect = (recipe) => {
    setSelectedRecipe(recipe);
    window.scrollTo(0, 0);
  };

  const handleCloseRecipeDetail = () => {
    setSelectedRecipe(null);
  };

  if (selectedRecipe) {
    return (
      <div className="app">
        {/* <TermsModal showActions={showActions} /> */}
        <div ref={topBarRef}><TopBar onSelectRecipe={handleRecipeSelect} /></div>
        
        <div>
          <RecipeDetailPage recipe={selectedRecipe} onBack={handleCloseRecipeDetail} onSelectRecipe={handleRecipeSelect} />
        </div>
        <Footer setShowActions={setShowActions} />
        <ChatRecipeWidget onSelectRecipe={handleRecipeSelect} />
      </div>
    );
  }

  return (
    <div className="app">
      <div ref={topBarRef}><TopBar onSelectRecipe={handleRecipeSelect} /></div>
      
      {showBanner && <Banner />}
      <main className="main-content">
        <RecipeBuilder onSelectRecipe={handleRecipeSelect} setShowBanner={setShowBanner} scrollToTop={scrollToTop} />
        <ArrowIndicator />
        <RecommendedRecipes onSelectRecipe={handleRecipeSelect} />
      </main>
      <Footer setShowActions={setShowActions} />
      <ChatRecipeWidget onSelectRecipe={handleRecipeSelect} />
    </div>
  );
}

function App() {
    useGlobalGaClickTracking();
  return (
    
    <Routes>
      <Route path="/terms" element={<TermsPage />} />
      <Route path="/thank-you" element={<ThankYouPage />} />
      <Route
        path="/"
        element={ <MainApp /> }
      />
    </Routes>
  );
}

export default App;
